/* ==========================================================================
   oh-th.js — Optimal Human · Hydration FREE TRIAL lander · flavor state

   ONE job: the page-wide flavor choice (Strawberry Lemonade "sl" / Lemon Lime
   "ll"). The buy box is where the customer picks; every other section only
   REACTS. Nothing here re-implements oh-engine.js or oh-tf.js.

   CONTRACT (every oh-kt-* section relies on exactly this, nothing more):

   <html data-th-flavor="sl|ll">
       Set synchronously by snippets/oh-kt-flavor-boot.liquid (rendered at the
       top of the first section) so there is no flash, then kept in sync here.
       CSS in oh-th.css hides [data-th-only="ll"] unless the attribute is "ll"
       and hides [data-th-only="sl"] when it is "ll" — so with NO attribute and
       NO JS the page shows Strawberry Lemonade, never both, never neither.

   [data-th-set-flavor="sl|ll"]    click (or Enter/Space on non-buttons) sets
       the flavor. Gets aria-pressed (buttons) / aria-checked (role=radio) and
       .is-on kept in sync. Inside a [role=radiogroup] the arrow keys move.

   a[data-th-checkout] with data-href-sl / data-href-ll
       href is swapped to the current flavor's checkout URL. An EMPTY data-href
       means that flavor has no selling plan yet: the link gets
       aria-disabled="true" and clicks are swallowed. It never falls back to a
       plain /cart/add — that would sell the box one-time at full price instead
       of starting the trial. (Fail closed.)

   a[data-th-cta]    every non-offer CTA. href="#th-offer" for no-JS; with JS it
       smooth-scrolls to #th-offer, clearing any fixed bar, then moves focus to
       [data-th-offer-focus] without scrolling again.

   [data-th-text-sl] / [data-th-text-ll]   textContent swapped per flavor
       (e.g. "Strawberry Lemonade" in a sticky label).

   Events: document dispatches CustomEvent("ohth:flavor", {detail:{flavor, source}})
   after every change. window.OHTH = { flavor, set(f, source), on(cb) }.
   Persistence: localStorage "ohkt_flavor" (try/catch — private mode throws).
   URL override: ?flavor=sl|ll (ads can deep-link a flavor).
   ========================================================================== */
(function () {
  'use strict';
  if (window.OHTH) return;

  var KEY = 'ohkt_flavor';
  var root = document.documentElement;

  function norm(f) { return f === 'sl' || f === 'll' ? f : null; }

  function initial() {
    var f = norm(root.getAttribute('data-th-flavor'));
    if (f) return f;
    try { f = norm(new URLSearchParams(location.search).get('flavor')); if (f) return f; } catch (e) {}
    try { f = norm(localStorage.getItem(KEY)); if (f) return f; } catch (e) {}
    return 'sl';
  }

  var state = { flavor: initial() };

  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }

  function paint() {
    var f = state.flavor;
    root.setAttribute('data-th-flavor', f);

    each('[data-th-set-flavor]', function (el) {
      var on = el.getAttribute('data-th-set-flavor') === f;
      el.classList.toggle('is-on', on);
      if (el.getAttribute('role') === 'radio') {
        el.setAttribute('aria-checked', on ? 'true' : 'false');
        el.setAttribute('tabindex', on ? '0' : '-1');
      } else if (el.tagName === 'BUTTON') {
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });

    each('a[data-th-checkout]', function (a) {
      var href = a.getAttribute('data-href-' + f) || '';
      if (href) {
        a.setAttribute('href', href);
        a.removeAttribute('aria-disabled');
      } else {
        a.setAttribute('href', '#th-offer');
        a.setAttribute('aria-disabled', 'true');
      }
    });

    each('[data-th-text-' + f + ']', function (el) {
      el.textContent = el.getAttribute('data-th-text-' + f);
    });
  }

  function set(f, source) {
    f = norm(f);
    if (!f) return;
    var changed = f !== state.flavor;
    state.flavor = f;
    try { localStorage.setItem(KEY, f); } catch (e) {}
    paint();
    if (changed || source === 'init') {
      try {
        document.dispatchEvent(new CustomEvent('ohth:flavor', { detail: { flavor: f, source: source || 'api' } }));
      } catch (e) {}
    }
  }

  function fixedOffset() {
    /* Clear whatever is pinned to the top edge right now (announcement bar,
       theme header). Measured live because the bar collapses when its timer ends. */
    var max = 0;
    each('.oh-tf-bar, .oh-kt-bar, header, [data-th-fixed-top]', function (el) {
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > 0) max = Math.max(max, r.bottom);
      }
    });
    return max + 12;
  }

  function goOffer(focus) {
    var target = document.getElementById('th-offer');
    if (!target) return false;
    /* On phones the buy box stacks pack photo → gallery → card, so the top of
       #th-offer is a photo and the flavor picker sits about a screen lower. Land on
       the picker itself there; on desktop the whole buy box fits, so keep the top. */
    var narrow = false;
    try { narrow = matchMedia('(max-width: 900px)').matches; } catch (e) {}
    var pick = target.querySelector('[data-th-offer-focus]');
    var anchor = (narrow && pick) ? pick : target;
    var reduce = false;
    try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var y = anchor.getBoundingClientRect().top + window.pageYOffset - fixedOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (focus) {
      var f = target.querySelector('[data-th-offer-focus]') || target;
      if (!f.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(f.tagName)) f.setAttribute('tabindex', '-1');
      setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 450);
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var sw = t.closest('[data-th-set-flavor]');
    if (sw) {
      if (sw.tagName === 'A') e.preventDefault();
      set(sw.getAttribute('data-th-set-flavor'), 'click');
      return;
    }

    var co = t.closest('a[data-th-checkout]');
    if (co && co.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      goOffer(true);
      return;
    }

    var cta = t.closest('a[data-th-cta]');
    if (cta && goOffer(true)) {
      e.preventDefault();
    }
  });

  document.addEventListener('keydown', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    if ((e.key === 'Enter' || e.key === ' ') && el.hasAttribute && el.hasAttribute('data-th-set-flavor') && el.tagName !== 'BUTTON') {
      e.preventDefault();
      set(el.getAttribute('data-th-set-flavor'), 'key');
      return;
    }

    var group = el.closest('[role="radiogroup"]');
    if (!group || !el.hasAttribute('data-th-set-flavor')) return;
    var k = e.key;
    if (k !== 'ArrowRight' && k !== 'ArrowDown' && k !== 'ArrowLeft' && k !== 'ArrowUp') return;
    var radios = Array.prototype.slice.call(group.querySelectorAll('[data-th-set-flavor]'));
    var i = radios.indexOf(el);
    if (i < 0) return;
    e.preventDefault();
    var next = radios[(i + ((k === 'ArrowRight' || k === 'ArrowDown') ? 1 : radios.length - 1)) % radios.length];
    set(next.getAttribute('data-th-set-flavor'), 'key');
    next.focus();
  });

  window.OHTH = {
    get flavor() { return state.flavor; },
    set: set,
    go: goOffer,
    on: function (cb) {
      document.addEventListener('ohth:flavor', function (ev) { cb(ev.detail.flavor, ev.detail.source); });
    }
  };

  function boot() { set(state.flavor, 'init'); }
  if (document.readyState === 'loading') {
    root.setAttribute('data-th-flavor', state.flavor);
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
